<div [ngClass]="{'d-none': loading}" *ngIf="!noStats" class="col-12">
  <div id="{{chartId}}"></div>
</div>
<div class="col-12 text-center" *ngIf="loading">
  <br/><br/><br/>
  <app-calibrant-load [small]="true"></app-calibrant-load>
</div>
<div class="col-12 text-center" *ngIf="noStats">
  <br/><br/><br/>
  <fa-icon i18n-ngbTooltip ngbTooltip="Error getting GA." [icon]="['fas', 'exclamation-triangle']" size="3x"></fa-icon>
</div>
